import styled from 'styled-components';

const SMALL_SIZE = 'small';

const PageHeadingStyled = styled.h1`
  align-items: center;
  align-self: flex-start;
  display: flex;
  margin: 0 0 24px;
  text-decoration: none;
  cursor: pointer;

  & > a {
    text-decoration: none;
  }
`;

const PageTitleStyled = styled.span`
  color: #ffffff;
  font-size: ${props => (props.size === SMALL_SIZE ? '20px' : '26px')};
  font-weight: 700;
  line-height: ${props => (props.size === SMALL_SIZE ? '26px' : '32px')};
`;

const IconStyled = styled.svg`
  margin: ${props =>
    props.size === SMALL_SIZE ? '0 18px 0 0' : '0 24px 0 6px '};
  position: relative;
  top: ${props => (props.size === SMALL_SIZE ? '4px' : '0')};
`;

export { PageHeadingStyled, PageTitleStyled, IconStyled };
